export default "__VITE_ASSET__hMc54jSl__"